import { display } from '@mui/system';
import { alpha } from '@mui/material';
import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.whitePepper.main,
  },

  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    rowGap: `25px`,
    maxHeight: '100%',
    [theme.breakpoints.down('md')]: {
      padding: '10px 0px',
      width: '100%',
      flexGrow: 1,
    },
  },

  bottomContainer: {
    margin: '25px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  addBtn: {
    width: '350px !important',

    [theme.breakpoints.down('md')]: {
      width: '260px !important',
    },
  },
});
